var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Column, Entity, Index, JoinColumn, ManyToOne, PrimaryColumn, Unique } from 'typeorm';
let Domain = class Domain {
    id;
    name;
    project;
    projectId;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Domain.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Domain.prototype, "name", void 0);
__decorate([
    Index(),
    ManyToOne('Project', (project) => project.assets, { nullable: false, onDelete: 'CASCADE' }),
    JoinColumn({ name: 'projectId' }),
    __metadata("design:type", Function)
], Domain.prototype, "project", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Domain.prototype, "projectId", void 0);
Domain = __decorate([
    Entity(),
    Unique(['projectId', 'name'])
], Domain);
export { Domain };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9tYWluLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2RvbWFpbi9tb2RlbHMvZG9tYWluLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxVQUFVLEVBQUUsU0FBUyxFQUFFLGFBQWEsRUFBRSxNQUFNLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFLdkYsSUFBTSxNQUFNLEdBQVosTUFBTSxNQUFNO0lBRWpCLEVBQUUsQ0FBVTtJQUdaLElBQUksQ0FBVTtJQUtkLE9BQU8sQ0FBVztJQUdsQixTQUFTLENBQVU7Q0FDcEIsQ0FBQTtBQVpDO0lBREMsYUFBYSxDQUFDLE1BQU0sRUFBRSxFQUFFLE9BQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQyxVQUFVLEVBQUUsQ0FBQzs7a0NBQ3pDO0FBR1o7SUFEQyxNQUFNLEVBQUU7O29DQUNLO0FBS2Q7SUFIQyxLQUFLLEVBQUU7SUFDUCxTQUFTLENBQUMsU0FBUyxFQUFFLENBQUMsT0FBZ0IsRUFBRSxFQUFFLENBQUMsT0FBTyxDQUFDLE1BQU0sRUFBRSxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxDQUFDO0lBQ3BHLFVBQVUsQ0FBQyxFQUFFLElBQUksRUFBRSxXQUFXLEVBQUUsQ0FBQzs7dUNBQ2hCO0FBR2xCO0lBREMsTUFBTSxDQUFDLE1BQU0sQ0FBQzs7eUNBQ0k7QUFiUixNQUFNO0lBRmxCLE1BQU0sRUFBRTtJQUNSLE1BQU0sQ0FBQyxDQUFDLFdBQVcsRUFBRSxNQUFNLENBQUMsQ0FBQztHQUNqQixNQUFNLENBY2xCIn0=